import { AfterViewInit, ChangeDetectorRef, Component, ContentChild, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';

import { SedsPositionsOptions } from '../../../shared/enums/seds-positions-options.enum';
import { SedsPositionsOptionsType } from '../../../shared/types/seds-positions-options.type';

@Component({
    selector: 'seds-form-field-text',
    templateUrl: './seds-form-field-text.component.html',
    styleUrls: [],
    standalone: false
})
export class SedsFormFieldTextComponent implements AfterViewInit {
  @Input() iconName?: string;
  @Input() iconPosition?: SedsPositionsOptions | SedsPositionsOptionsType;
  @Input() label!: string;
  @Input() warningColor = false;
  @ContentChild(MatFormFieldControl) _control!: any;

  constructor(private readonly cdref: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }
}
